/* ==========================================================================
   Indidha FBT - JavaScript Engine
   ========================================================================== */

window.InitFBTEngine = function() {
  const container = document.querySelector('.fbt-inner-container');
  if (!container) return;

  const checkboxes = container.querySelectorAll('.fbt-selector-checkbox');
  const variantSelects = container.querySelectorAll('.fbt-variant-select');
  const submitBtn = document.getElementById('fbt-submit-btn');
  
  const totalPriceEl = document.getElementById('fbt-total-price');
  const totalSavingsEl = document.getElementById('fbt-total-savings');
  const savingsRow = document.getElementById('fbt-savings-row');
  const selectedCountEl = document.getElementById('fbt-selected-count');

  // Hardcode Rupee symbol with spacing for consistent aesthetic
  const currencySymbol = '₹ ';

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(2);
    const formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return `${currencySymbol}${formattedValue}`;
  }

  function calculateTotals() {
    let total = 0;
    let compareTotal = 0;
    let count = 0;

    checkboxes.forEach(box => {
      if (box.checked) {
        count++;
        const card = box.closest('.fbt-product-card');
        const select = card.querySelector('.fbt-variant-select');
        
        let price = 0;
        let comparePrice = 0;

        if (select.tagName === 'SELECT') {
          const option = select.options[select.selectedIndex];
          price = parseInt(option.getAttribute('data-price') || 0);
          comparePrice = parseInt(option.getAttribute('data-compare-price') || price);
        } else {
          price = parseInt(select.getAttribute('data-price') || 0);
          comparePrice = parseInt(select.getAttribute('data-compare-price') || price);
        }

        total += price;
        compareTotal += comparePrice;
      }
    });

    if (selectedCountEl) selectedCountEl.innerText = count;
    
    // Inject dual-price display for the total summary with stark hierarchy
    if (totalPriceEl) {
      totalPriceEl.innerHTML = `
        <div style="display: flex; align-items: center; justify-content: flex-end;">
          <span class="fbt-price-compare" style="font-size: 14px; text-decoration: line-through; color: #707070; margin-right: 8px;">
            ${formatMoney(compareTotal)}
          </span>
          <span class="fbt-price-current" style="font-size: 18px; font-weight: 600; color: #000000;">
            ${formatMoney(total)}
          </span>
        </div>
      `;
    }

    const totalSavings = compareTotal - total;
    
    if (totalSavings > 0 && savingsRow) {
      savingsRow.classList.remove('fbt-visual-hide');
      if (totalSavingsEl) totalSavingsEl.innerText = formatMoney(totalSavings);
    } else if (savingsRow) {
      savingsRow.classList.add('fbt-visual-hide');
    }

    if (submitBtn) submitBtn.disabled = count === 0;
  }

  function updateCardPrice(card, select) {
    if (select.tagName !== 'SELECT') return;
    
    const option = select.options[select.selectedIndex];
    const price = parseInt(option.getAttribute('data-price') || 0);
    const comparePrice = parseInt(option.getAttribute('data-compare-price') || price);
    
    const priceCurrentEl = card.querySelector('.fbt-price-current');
    const priceCompareEl = card.querySelector('.fbt-price-compare');
    
    if (priceCurrentEl) priceCurrentEl.innerText = formatMoney(price);
    
    if (priceCompareEl) {
      if (comparePrice > price) {
        priceCompareEl.innerText = formatMoney(comparePrice);
        priceCompareEl.style.display = 'inline-block';
      } else {
        priceCompareEl.style.display = 'none';
      }
    }
  }

  checkboxes.forEach(box => {
    box.addEventListener('change', calculateTotals);
  });

  variantSelects.forEach(select => {
    select.addEventListener('change', function() {
      const card = this.closest('.fbt-product-card');
      updateCardPrice(card, this);
      calculateTotals();
    });
  });

  if (submitBtn) {
    submitBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      const items = [];
      checkboxes.forEach(box => {
        if (box.checked) {
          const card = box.closest('.fbt-product-card');
          const select = card.querySelector('.fbt-variant-select');
          items.push({
            id: parseInt(select.value),
            quantity: 1
          });
        }
      });

      if (items.length === 0) return;

      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(data => {
        window.dispatchEvent(new Event('cart:updated'));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));

        const checkoutBtn = document.querySelector('[name="checkout"], form[action^="/cart"] [type="submit"]');
        
        if (checkoutBtn) {
          checkoutBtn.click();
        } else {
          window.location.href = window.Shopify.routes.root + 'cart';
        }
        
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;
      })
      .catch((error) => {
        console.error('FBT Cart Error:', error);
        submitBtn.classList.remove('is-loading');
        submitBtn.disabled = false;
        alert('There was an error adding items to the cart. Please try again.');
      });
    });
  }

  calculateTotals();
};